import { render, staticRenderFns } from "./MessageOverlayDialog.vue?vue&type=template&id=1435e6ba&scoped=true"
import script from "./MessageOverlayDialog.vue?vue&type=script&lang=js"
export * from "./MessageOverlayDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1435e6ba",
  null
  
)

export default component.exports